module.exports = __webpack_public_path__ + "img/support.e94c37fe.svg";